const firebaseConfig = {
    apiKey: "AIzaSyBhxSNgutOeQRZac1OGvG0izQTAFGanzdc",
    authDomain: "binova-shoes.firebaseapp.com",
    projectId: "binova-shoes",
    storageBucket: "binova-shoes.appspot.com",
    messagingSenderId: "984786676645",
    appId: "1:984786676645:web:d2ad44317ccd21ba20964c"
  };
  export default firebaseConfig;